import { type ColumnOptions } from "interfaces";

export const getColumnOptions = (blackListEnabled: boolean): ColumnOptions[] => {
  const baseColumns: ColumnOptions[] = [
    { name: "Name", width: 3, isSortable: true, className: "user-name-header" },
    { name: "Department", width: 2, isSortable: true },
    { name: "Job title", width: 2, isSortable: true },
    { name: "Added", width: 3, isSortable: true },
    { name: "Last Login", width: 3, isSortable: true },
    { name: "", width: 2 },
  ];

  if (blackListEnabled) {
    baseColumns.splice(3, 0, { name: "No Contact", width: 3, isSortable: true });
  }
  return baseColumns;
};
